/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CommodityDetailCommodityManufacturer =
  (typeof CommodityDetailCommodityManufacturer)[keyof typeof CommodityDetailCommodityManufacturer];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityDetailCommodityManufacturer = {
  argo_heraeus: "argo_heraeus",
  pamp: "pamp",
  munze_osterreich: "munze_osterreich",
} as const;
